import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";

const ServiceCard = (props) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 670);

  return (
    <div
      className="services-item wow fadeInUp"
      style={{backgroundColor : "#1D1D25", width : isMobile && 280}}
      data-wow-delay={`.${props.item.delay_time}s`}
    >
      <div className="services-icon">
        <img src={`/img/icon/services_icon0${props.index + 1}.png`} alt="" />
      </div>
      <div className="services-content">
        <h4 className="title" style={{color : "#F7F7F7"}}>
          <Link 
          // to={props.item.url}
          >{props.item.title}</Link>
        </h4>
        <p style={{color : "white"}}>{props.item.desc}</p>
      </div>
    </div>
  );
};

export default ServiceCard;
